module.exports = __webpack_public_path__ + "static/kenku-fights-goblins-ayagww-ef60d2f1b6016b01d7307e29bb54eb09.jpg";